import { z } from 'zod';

// ── Modelos de resposta e apontamento (v5, módulo models) ───────────────────
// O uso é 100% client-side: o composer de comentário / form de apontamento
// insere `renderTemplate(body, vars)` (./render-template) com os dados do
// ticket já carregados — mesmas variáveis de TEMPLATE_VARIABLE_NAMES.

export const ResponseTemplateSchema = z.object({
  id: z.number().int(),
  /** null = modelo global (disponível para todas as mesas) */
  deskId: z.number().int().nullable(),
  name: z.string(),
  /** corpo com `{{variáveis}}` de TEMPLATE_VARIABLE_NAMES */
  body: z.string(),
  active: z.boolean(),
  position: z.number().int(),
});
export type ResponseTemplate = z.infer<typeof ResponseTemplateSchema>;

/** Mesma forma do modelo de resposta — tabela própria, contrato próprio. */
export const AppointmentTemplateSchema = ResponseTemplateSchema;
export type AppointmentTemplate = z.infer<typeof AppointmentTemplateSchema>;

/** POST/PUT de ambos os tipos de modelo; deskId ausente/null = global. */
export const ModelTemplateBodySchema = z.object({
  name: z.string().min(1),
  body: z.string().min(1),
  deskId: z.number().int().positive().nullish(),
  active: z.boolean().optional(),
});
export type ModelTemplateBody = z.infer<typeof ModelTemplateBodySchema>;

/** GET com desk_id devolve os da mesa E os globais (deskId null), por position. */
export const ModelTemplateListQuerySchema = z.object({
  desk_id: z.coerce.number().int().positive().optional(),
});
export type ModelTemplateListQuery = z.infer<typeof ModelTemplateListQuerySchema>;
